import React from "react";
import "./Experience.css";

const experiences = [
  {
    badge: "Current Role",
    title: "Full Stack Developer — Project Associate",
    company: "Indian Institute of Technology, Kanpur",
    location: "Kanpur, India",
    date: "Dec 2024 – Present",
    points: [
      "Engineered a real-time Energy Management and PMU Monitoring Platform using React 19, Django, PostgreSQL, FastAPI, Kafka, and InfluxDB — processing 10,000+ messages/sec across 15+ electrical substations with 99.9% system availability.",
      "Enhanced a React TypeScript monitoring dashboard with custom hooks, WebSockets, SSE, Recharts, and React Leaflet — enabling sub-second updates across 50+ devices and cutting operator response time by 40%.",
      "Improved backend performance through Redis caching, composite database indexing, JWT authentication, and RBAC — increasing data retrieval speed by 35% while securing access for 50+ multi-department users.",
      "Built and deployed Breaker Guard (UPPCL) using Django and React — integrating outage management workflows, IoT heartbeat monitoring, OTA firmware distribution, and live device geolocation mapping.",
      "Delivered production-grade platforms including the GREET Research Portal and UPCON 2026 Conference Management System with survey automation, email notifications, Excel reports, and responsive UI.",
    ],
    tags: [
      "React 19", "TypeScript", "Django", "FastAPI", "PostgreSQL", "InfluxDB",
      "Redis", "Apache Kafka", "Docker", "WebSocket", "JWT", "GitLab CI/CD",
    ],
  },
  {
    title: "Full Stack Developer — Intern",
    company: "SIIC Incubation Centre, IIT Kanpur",
    location: "Kanpur, India",
    date: "Jun 2024 – Dec 2024",
    points: [
      "Established a React and Laravel Incubation Management Portal with role-based dashboards (Admin, HR, Incubatee), multi-stage workflows, and document management (PDF, ZIP, in-browser viewing) — processing 500+ monthly submissions.",
      "Applied RBAC with dynamically configurable module-level permissions using Laravel Gates and Policies, reducing manual processing time by 40%.",
      "Built the NIDHI SSS Portal with bulk CSV exports and advanced search filters, improving retrieval efficiency by 60%.",
      "Configured an SMTP notification system generating 200+ weekly alerts, lowering manual follow-up effort by 70%.",
      "Launched the MedTech CoE institutional website (medtechcoe.siicincubator.com) using PHP, Bootstrap, and reusable modular components.",
    ],
    tags: [
      "React.js", "Laravel", "PHP", "MySQL", "Django", "Bootstrap",
      "jQuery", "SMTP", "DomPDF", "Vite.js",
    ],
  },
];

function Experience() {
  return (
    <section id="experience" className="experience section-band">
      <div className="section-inner">
        <header className="section-header">
          <div className="section-label">Experience</div>
          <h2 className="section-title">
            Professional <em>Journey</em>
          </h2>
          <p className="section-subtitle">
            Building real-time monitoring platforms and enterprise web systems at IIT Kanpur.
          </p>
        </header>

        <div className="exp__timeline ui-timeline">
          {experiences.map((exp, idx) => (
            <div key={idx} className="ui-timeline__item reveal">
              <div className="ui-timeline__marker" aria-hidden="true">
                <span className="ui-timeline__dot" />
                {idx < experiences.length - 1 && <span className="ui-timeline__line" />}
              </div>

              <article className="exp__body ui-card">
                {exp.badge && (
                  <span className="ui-badge ui-badge--live">
                    <span className="ui-badge__dot" aria-hidden="true" /> {exp.badge}
                  </span>
                )}
                <div className="exp__header">
                  <div>
                    <h3 className="card-title">{exp.title}</h3>
                    <p className="card-meta">{exp.company}</p>
                    <p className="exp__location">{exp.location}</p>
                  </div>
                  <time className="exp__date">{exp.date}</time>
                </div>
                <ul className="exp__points">
                  {exp.points.map((pt, i) => (
                    <li key={i}>{pt}</li>
                  ))}
                </ul>
                <div className="tag-row">
                  {exp.tags.map((t) => (
                    <span key={t} className="tag">{t}</span>
                  ))}
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
